@if(isEnabled) {
<aside
    class="drawer"
    id="drawer"
    [class.open]="isDrawerOpen()"
    (click)="$event.stopPropagation()"
>
    @if(isDrawerOpen()) {
        <button
            class="drawer-edge-btn"
            id="drawerEdgeBtn"
            aria-label="Abrir/Fechar chat"
            matTooltip="Chat de Ajuda"
            (click)="toggleDrawer($event)"
        >
            <span class="icon"></span>
        </button>
    }

    <div class="drawer-content">
        <df-messenger
            aria-label="Assistente virtual iAGU Sapiens"
            project-id="agu-diji-chatbot"
            agent-id="815c4e4f-bb9c-4568-bac5-4936340b12ae"
            language-code="pt-pt"
            max-query-length="-1"
            allow-feedback="all"
            expand="true"
        >
            <df-messenger-chat
                aria-label="Chat iAGU Sapiens"
                chat-title="iAGUSapiens"
                chat-subtitle="Ajuda do Super Sapiens"
                placeholder-text="Faça aqui a sua pergunta"
                chat-title-icon="assets/images/logos/iagu_01.ico"
            >
            </df-messenger-chat>
        </df-messenger>
    </div>
</aside>
}
